module.exports = __webpack_public_path__ + "static/assets/1c6d2342a282759e4246bf6868e32c52.png";